import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context/AppContext'; // <-- Import AppProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
const isPublicChartRoute = /^\/charts(?:\/|$)/.test(window.location.pathname);

root.render(
   <React.StrictMode>
    {isPublicChartRoute ? (
      <App />
    ) : (
      <AppProvider>
        <App />
      </AppProvider>
    )}
  </React.StrictMode>
);

reportWebVitals();
